import { AppShell, PageHeader } from '../../../components/layout';
import { Card } from '../../../components/ui';
import ChapterReader from '../../../components/reader/ChapterReader';

export default function ChapterRead({ student, lesson, book, chapter, html, analyzed_sentences }) {
  return (
    <AppShell
      student={student}
      scrollTitle={chapter.formatted_label || chapter.title}
    >
      <div className="max-w-3xl mx-auto">
        <PageHeader
          backLink={`/student/lessons/${lesson.id}`}
          backLabel={lesson.title}
          title={chapter.formatted_label || chapter.title}
          subtitle={book?.title}
        />

        <Card className="px-8 sm:px-10 py-8">
          <ChapterReader
            readOnly
            book={null}
            chapter={chapter}
            html={html}
            analyzedSentences={analyzed_sentences}
          />
        </Card>
      </div>
    </AppShell>
  );
}
